// cart-empty-handler.js
(function() {
  let isHandling = false;

  async function initializeValidation() {
    const existingCounter = document.querySelector('.character-counter');
    const existingError = document.querySelector('.message-card-error');
    if (existingCounter) existingCounter.remove();
    if (existingError) existingError.remove();

    const validator = new MessageCardValidator('messageText', 'saveMessageButton');
    if (validator) {
      validator.init();
    }
    addCharacterCounter('messageText');

    return validator;
  }

  window.closeModal = function(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const modal = document.getElementById('messageModal');
    const drawer = document.querySelector('.Drawer--fromRight.Drawer__Cart');
    if (modal && drawer) {
      window.isModalOpen = false;
      modal.classList.remove('show');
      drawer.classList.remove('modalshow');
    }
  };

  window.saveMessage = async function(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  
    try {
      const messageText = document.getElementById('messageText');
      if (messageText) {
        const validator = new MessageCardValidator('messageText', 'saveMessageButton');
        if (!validator.isValid()) {
          return;
        }
  
        const selectedCardType = document.querySelector('input[name="cardType"]:checked');
        const cardTypeValue = selectedCardType ? selectedCardType.value : '';
  
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              メッセージカード: messageText.value || null,
              カードタイプ: cardTypeValue || null
            },
          }),
        });
  
        const cart = await fetch('/cart.js').then(res => res.json());
        
        const messageActions = document.querySelector('.message-actions');
        if (messageActions) {
          const hasMessage = cart.attributes['メッセージカード'] && 
                           cart.attributes['メッセージカード'] !== 'null' && 
                           cart.attributes['メッセージカード'] !== '';
          
          messageActions.style.display = hasMessage ? 'block' : 'none';
        }
  
        closeModal();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        setTimeout(async () => {
          const updatedCart = await fetch('/cart.js').then(res => res.json());
          await updateMessageActions(updatedCart);
        }, 500);
      }
    } catch (error) {
      console.error('Error in saveMessage:', error);
    }
  };

  async function showModal() {
    const modal = document.getElementById('messageModal');
    const drawer = document.querySelector('.Drawer--fromRight.Drawer__Cart');
    
    if (modal && drawer) {
      window.isModalOpen = true;
      modal.classList.add('show');
      drawer.classList.add('modalshow');
  
      const messageText = document.getElementById('messageText');
      if (messageText) {
        messageText.readOnly = false;
        messageText.disabled = false;
  
        const cart = await fetch('/cart.js').then(res => res.json());
        messageText.value = cart.attributes['メッセージカード'] || '';
  
        const cardType = cart.attributes['カードタイプ'];
        if (cardType) {
          const radioButton = document.querySelector(`input[name="cardType"][value="${cardType}"]`);
          if (radioButton) {
            radioButton.checked = true;
          }
        }
  
        await new Promise(resolve => setTimeout(resolve, 50));
        await initializeValidation();
  
        messageText.focus();
        messageText.setSelectionRange(messageText.value.length, messageText.value.length);
      }
    }
  }

  window.onclick = function(event) {
    const modal = document.getElementById('messageModal');
    if (event.target === modal) {
      closeModal();
    }
  };

  async function handleEmptyCart() {
    if (isHandling) return;
    isHandling = true;
  
    try {
      const cart = await fetch('/cart.js').then(res => res.json());
  
      if (cart.item_count === 1) {
        await new Promise(resolve => setTimeout(resolve, 500));
        initializeModalTriggers();
      }
  
      updateMessageActions(cart);
  
      if (cart.item_count === 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              メッセージカード: null,
              カードタイプ: null
            },
          }),
        });
  
        const messageActions = document.querySelector('.message-actions');
        if (messageActions) {
          messageActions.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Error in handleEmptyCart:', error);
    } finally {
      isHandling = false;
    }
  }

  async function handleMessageButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const cart = await fetch('/cart.js').then(res => res.json());
    if (cart.item_count > 0) {
      showModal();
    }
  }

  async function updateMessageActions(cart) {
    const messageActions = document.querySelector('.message-actions');
    if (messageActions) {
      const hasMessage = cart.attributes['メッセージカード'] && 
                        cart.attributes['メッセージカード'] !== 'null' && 
                        cart.attributes['メッセージカード'] !== '';
      const hasCardType = cart.attributes['カードタイプ'] && 
                         cart.attributes['カードタイプ'] !== 'null' && 
                         cart.attributes['カードタイプ'] !== '';
                        
      if (hasMessage && hasCardType && cart.item_count > 0) {
        messageActions.style.display = 'block';
      } else {
        messageActions.style.display = 'none';
      }
    }
  }

  function setupCartDrawerObserver() {
    const observer = new MutationObserver(() => {
      handleEmptyCart();
      initializeModalTriggers();
    });

    const drawerContainer = document.querySelector('.Drawer.Drawer--fromRight.Drawer__Cart');
    if (drawerContainer) {
      observer.observe(drawerContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  window.deleteMessage = async function(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            メッセージカード: null,
            カードタイプ: null
          },
        }),
      });
  
      const messageActions = document.querySelector('.message-actions');
      if (messageActions) {
        messageActions.style.display = 'none';
      }
  
      const messageText = document.getElementById('messageText');
      if (messageText) {
        messageText.value = '';
      }
  
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      console.error('Error in deleteMessage:', error);
    }
  };

  async function editModalClickHandler(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  
    if (window.isProcessing) return;
    window.isProcessing = true;
  
    try {
      const messageText = document.getElementById('messageText');
      const modal = document.getElementById('messageModal');
      const drawer = document.querySelector('.Drawer--fromRight.Drawer__Cart');
      
      if (modal && messageText && drawer) {
        window.isModalOpen = true;
        modal.classList.add('show');
        drawer.classList.add('modalshow');
  
        messageText.readOnly = false;
        messageText.disabled = false;
  
        const existingCounters = document.querySelectorAll('.character-counter');
        existingCounters.forEach(counter => counter.remove());
        const existingErrors = document.querySelectorAll('.message-card-error');
        existingErrors.forEach(error => error.remove());
  
        const cart = await fetch('/cart.js').then(res => res.json());
        messageText.value = cart.attributes['メッセージカード'] || '';
  
        await new Promise(resolve => setTimeout(resolve, 50));
        await initializeValidation();
  
        messageText.focus();
        messageText.setSelectionRange(messageText.value.length, messageText.value.length);
      }
    } catch (error) {
      console.error('Error in editModalClickHandler:', error);
    } finally {
      window.isProcessing = false;
    }
  }

  function setupEventListeners() {
    const cartUpdateHandler = async () => {
      await handleEmptyCart();
      initializeModalTriggers(); 
    };

    document.addEventListener('cart:updated', cartUpdateHandler);
    document.addEventListener('cart:refresh', cartUpdateHandler);
    document.addEventListener('ajaxProduct:added', cartUpdateHandler);
    document.addEventListener('ajaxProduct:updated', cartUpdateHandler);
    document.addEventListener('cart:build', async () => {
      await new Promise((resolve) => setTimeout(resolve, 300));
      initializeModalTriggers();
    });

    document.addEventListener('click', (event) => {
      const editButton = event.target.closest('[data-action="edit-modal"]');
      if (editButton) {
        editModalClickHandler(event);
      }
    });
  }

  function initializeModalTriggers() {
    const addButtons = document.querySelectorAll('.Drawer--fromRight.Drawer__Cart [data-action="open-modal"]');
    addButtons.forEach(button => {
      button.removeEventListener('click', handleMessageButtonClick);
      button.addEventListener('click', handleMessageButtonClick);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    setupCartDrawerObserver();
    setupEventListeners();
    initializeModalTriggers();
  });

  document.addEventListener('shopify:section:load', () => {
    setupCartDrawerObserver();
    setupEventListeners();
    initializeModalTriggers();
  });
})();